import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyDRNaqutVx3_4GSICGj7twT7Qr9qje1i7k",
  authDomain: "mymetricsbody.firebaseapp.com",
  projectId: "mymetricsbody",
  storageBucket: "mymetricsbody.firebasestorage.app",
  messagingSenderId: "532839814840",
  appId: "1:532839814840:web:135ab659502d1c807c864d",
  measurementId: "G-TK7BMJRS5C"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
